const initialize = () => {
    let apiAccessDeleteModal = document.getElementById('apiAccessDeleteModal');
    if (!apiAccessDeleteModal) {
        return;
    }
    apiAccessDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let accessToken = button.data('accesstoken');
        let action = button.data('action');

        let modal = $(this);
        modal.find('#apiAccessDelete').attr('action', action);
        modal.find('#accessToken').val(accessToken);
    })
};

export default initialize;
